import React from 'react';
import { useNavigate } from 'react-router-dom';
import Card from './common/Card';
import Header from './common/Header';
import { theme } from '../styles/theme';

const AuditProgram = ({ user, setUser }) => {
  const navigate = useNavigate();

  const features = [
    {
      title: 'Audit Schedule',
      description: 'Manage and view all audit schedules, create new schedules, and track audit status.',
      path: '/max-comply/audit-schedule',
      icon: '📅'
    },
    {
      title: 'QA Certifications',
      description: 'Manage quality assurance certifications and qualifications for personnel.',
      path: '/max-comply/qa-certifications',
      icon: '🎓'
    },
    {
      title: 'Audit Management',
      description: 'Execute and track audits, findings, and corrective actions.',
      path: '/max-comply/audit-management',
      icon: '📊'
    },
    {
      title: 'Forms & Documents',
      description: 'Access and manage quality assurance forms and documentation.',
      path: '/max-comply/forms-documents',
      icon: '📄'
    },
    {
      title: 'Root Cause Analysis',
      description: 'Tools for investigating and analyzing quality issues.',
      path: '/max-comply/root-cause-analysis',
      icon: '🔍'
    },
    {
      title: 'QA Training',
      description: 'Quality assurance training management and tracking.',
      path: '/max-comply/qa-training',
      icon: '👥'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header 
        user={user} 
        setUser={setUser}
        title="Audit Program"
      />

      <main className="container mx-auto px-4 py-8">
        <div className="max-w-6xl mx-auto">
          <h1 className="text-2xl font-bold mb-2" style={{ color: theme.colors.text.primary }}>
            Quality Assurance Management
          </h1>
          <p className="text-lg mb-6" style={{ color: theme.colors.text.secondary }}>
            Comprehensive tools for managing aviation quality assurance programs
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {features.map((card, index) => (
              <Card 
                key={index}
                className="cursor-pointer transform transition-all duration-200 hover:-translate-y-1 hover:shadow-lg"
                onClick={() => navigate(card.path)}
              >
                <div className="p-6">
                  <div className="flex items-start space-x-4 mb-4">
                    <div 
                      className="w-12 h-12 rounded-lg flex items-center justify-center text-2xl"
                      style={{ 
                        background: `linear-gradient(to bottom right, ${theme.colors.primary.main}, ${theme.colors.primary.dark})`,
                        color: 'white'
                      }}
                    >
                      {card.icon}
                    </div>
                    <div>
                      <h2 className="text-xl font-semibold mb-2" style={{ color: theme.colors.text.primary }}>
                        {card.title}
                      </h2>
                      <p className="text-base" style={{ color: theme.colors.text.secondary }}>
                        {card.description}
                      </p>
                    </div>
                  </div>
                  <div 
                    className="flex items-center text-sm mt-4" 
                    style={{ color: theme.colors.primary.main }}
                  >
                    <span>View Details</span>
                    <svg 
                      className="w-4 h-4 ml-2" 
                      fill="none" 
                      stroke="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path 
                        strokeLinecap="round" 
                        strokeLinejoin="round" 
                        strokeWidth={2} 
                        d="M9 5l7 7-7 7" 
                      />
                    </svg>
                  </div>
                </div>
              </Card>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default AuditProgram;
